export enum SolIcon {
  accepted = 'accepted',
  access_point = 'access_point',
  agent = 'agent',
  ai = 'ai',
  api = 'api',
  appliance = 'appliance',
  application = 'application',
  archive = 'archive',
  arrow_down = 'arrow_down',
  arrow_left = 'arrow_left',
  arrow_merge = 'arrow_merge',
  arrow_right = 'arrow_right',
  arrow_up = 'arrow_up',
  arrows_right_left = 'arrows_right_left',
  arrows_split = 'arrows_split',
  arrows_up_down = 'arrows_up_down',
  asm_access_control = 'asm_access_control',
  asm_admin = 'asm_admin',
  asm_api = 'asm_api',
  asm_assets = 'asm_assets',
  asm_audit_logs = 'asm_audit_logs',
  asm_automation = 'asm_automation',
  asm_certificates = 'asm_certificates',
  asm_chevron_down = 'asm_chevron_down',
  asm_credentials = 'asm_credentials',
  asm_dark_web = 'asm_dark_web',
  asm_dashboard = 'asm_dashboard',
  asm_data_leakage = 'asm_data_leakage',
  asm_domain_discovery = 'asm_domain_discovery',
  asm_domains = 'asm_domains',
  asm_drp = 'asm_drp',
  asm_feature_flags = 'asm_feature_flags',
  asm_hosts = 'asm_hosts',
  asm_insights = 'asm_insights',
  asm_integrations = 'asm_integrations',
  asm_light = 'asm_light',
  asm_manual_scans = 'asm_manual_scans',
  asm_mobile_apps = 'asm_mobile_apps',
  asm_network = 'asm_network',
  asm_notifications = 'asm_notifications',
  asm_saved_searches = 'asm_saved_searches',
  asm_scope = 'asm_scope',
  asm_search = 'asm_search',
  asm_settings = 'asm_settings',
  asm_social_media = 'asm_social_media',
  asm_subscopes = 'asm_subscopes',
  asm_tags = 'asm_tags',
  asm_technologies = 'asm_technologies',
  asm_tracker = 'asm_tracker',
  asm_websites = 'asm_websites',
  asm_whats_new = 'asm_whats_new',
  asset = 'asset',
  asset_group = 'asset_group',
  asset_identifier = 'asset_identifier',
  asset_off = 'asset_off',
  attack_vector = 'attack_vector',
  authentication = 'authentication',
  automation = 'automation',
  award = 'award',
  back = 'back',
  background_activity = 'background_activity',
  balance_scale = 'balance_scale',
  ban = 'ban',
  blueprint = 'blueprint',
  bolt = 'bolt',
  bookmark = 'bookmark',
  bookmark_on = 'bookmark_on',
  books = 'books',
  braces = 'braces',
  brand_docker = 'brand_docker',
  brand_oauth = 'brand_oauth',
  brand_slack = 'brand_slack',
  brand_teams = 'brand_teams',
  brand_windows = 'brand_windows',
  brand_youtube = 'brand_youtube',
  browser_window = 'browser_window',
  browser_window_plus = 'browser_window_plus',
  browser_window_search = 'browser_window_search',
  calendar = 'calendar',
  camera = 'camera',
  camera_off = 'camera_off',
  caret_down = 'caret_down',
  cash = 'cash',
  cat = 'cat',
  catalog = 'catalog',
  certificate = 'certificate',
  chart_bar = 'chart_bar',
  chart_covariate = 'chart_covariate',
  chart_donut = 'chart_donut',
  chart_funnel = 'chart_funnel',
  chart_histogram = 'chart_histogram',
  chart_line = 'chart_line',
  chart_pie = 'chart_pie',
  chart_sankey = 'chart_sankey',
  chat = 'chat',
  chats = 'chats',
  check = 'check',
  check_square = 'check_square',
  chevron_down = 'chevron_down',
  chevron_left = 'chevron_left',
  chevron_right = 'chevron_right',
  chevron_up = 'chevron_up',
  chevrons_vertical = 'chevrons_vertical',
  circle = 'circle',
  circle_ban_small = 'circle_ban_small',
  circle_dashed_small = 'circle_dashed_small',
  circle_filled_small = 'circle_filled_small',
  circle_off = 'circle_off',
  clarification = 'clarification',
  cloud = 'cloud',
  cloud_discovery = 'cloud_discovery',
  cloud_download = 'cloud_download',
  cloud_off = 'cloud_off',
  column_insert_left = 'column_insert_left',
  column_insert_right = 'column_insert_right',
  column_remove = 'column_remove',
  compare = 'compare',
  compliance = 'compliance',
  configuration = 'configuration',
  confirmed = 'confirmed',
  copy = 'copy',
  credential = 'credential',
  critical = 'critical',
  cross_circle = 'cross_circle',
  customer = 'customer',
  dark_mode = 'dark_mode',
  dark_web = 'dark_web',
  dashboard = 'dashboard',
  database = 'database',
  delete = 'delete',
  dispute = 'dispute',
  docker_discovery = 'docker_discovery',
  document = 'document',
  document_css = 'document_css',
  document_csv = 'document_csv',
  document_doc = 'document_doc',
  document_html = 'document_html',
  document_json = 'document_json',
  document_move_into = 'document_move_into',
  document_pdf = 'document_pdf',
  document_search = 'document_search',
  document_sql = 'document_sql',
  document_tsx = 'document_tsx',
  document_txt = 'document_txt',
  document_xls = 'document_xls',
  document_xml = 'document_xml',
  document_zip = 'document_zip',
  documents = 'documents',
  domain = 'domain',
  domain_discovery = 'domain_discovery',
  download = 'download',
  easm = 'easm',
  edit = 'edit',
  envelope = 'envelope',
  environment = 'environment',
  error = 'error',
  exclamation = 'exclamation',
  export = 'export',
  false_positive = 'false_positive',
  feedback = 'feedback',
  filters = 'filters',
  filters_off = 'filters_off',
  finding = 'finding',
  fingerprint = 'fingerprint',
  flag = 'flag',
  flag_off = 'flag_off',
  folder = 'folder',
  folder_tree = 'folder_tree',
  form = 'form',
  gavel = 'gavel',
  grade_high = 'grade_high',
  grade_low = 'grade_low',
  grade_max = 'grade_max',
  grade_medium = 'grade_medium',
  grade_neutral = 'grade_neutral',
  grid_dots = 'grid_dots',
  grip_horizontal = 'grip_horizontal',
  grip_vertical = 'grip_vertical',
  guide = 'guide',
  handshake = 'handshake',
  heart = 'heart',
  help = 'help',
  high_contrast_mode = 'high_contrast_mode',
  history = 'history',
  host = 'host',
  id = 'id',
  image = 'image',
  import = 'import',
  in_progress = 'in_progress',
  info = 'info',
  integration = 'integration',
  internal = 'internal',
  key_command = 'key_command',
  key_control = 'key_control',
  key_option = 'key_option',
  key_shift = 'key_shift',
  key_space = 'key_space',
  keyboard = 'keyboard',
  knowledge_base = 'knowledge_base',
  leaked_secrets = 'leaked_secrets',
  license = 'license',
  light_mode = 'light_mode',
  link = 'link',
  link_alt = 'link_alt',
  list_bullets = 'list_bullets',
  list_numbers = 'list_numbers',
  lock = 'lock',
  lock_code = 'lock_code',
  lock_off = 'lock_off',
  lock_open = 'lock_open',
  log_out = 'log_out',
  logs = 'logs',
  managed_services = 'managed_services',
  menu_horizontal = 'menu_horizontal',
  menu_vertical = 'menu_vertical',
  menu = 'menu',
  minimize = 'minimize',
  minus = 'minus',
  minus_circle = 'minus_circle',
  mitigated = 'mitigated',
  monitor = 'monitor',
  monitor_off = 'monitor_off',
  move = 'move',
  nav_tree = 'nav_tree',
  network = 'network',
  network_alt = 'network_alt',
  network_discovery = 'network_discovery',
  new = 'new',
  night_mode = 'night_mode',
  nodes = 'nodes',
  note = 'note',
  notification = 'notification',
  number = 'number',
  open_new = 'open_new',
  overview = 'overview',
  package = 'package',
  patch = 'patch',
  pause = 'pause',
  pci = 'pci',
  pending = 'pending',
  percentage = 'percentage',
  phone = 'phone',
  pin = 'pin',
  pin_off = 'pin_off',
  placeholder = 'placeholder',
  play = 'play',
  plug = 'plug',
  plus = 'plus',
  plus_circle = 'plus_circle',
  plus_slash_minus = 'plus_slash_minus',
  policy = 'policy',
  printer = 'printer',
  properties = 'properties',
  prototype = 'prototype',
  query = 'query',
  r2d2 = 'r2d2',
  radar = 'radar',
  release_note = 'release_note',
  reload = 'reload',
  remove = 'remove',
  reorder = 'reorder',
  report = 'report',
  reset = 'reset',
  resolved = 'resolved',
  retro_save = 'retro_save',
  robot = 'robot',
  saved_view = 'saved_view',
  saved_view_on = 'saved_view_on',
  scan = 'scan',
  schedule = 'schedule',
  schema = 'schema',
  scope = 'scope',
  search = 'search',
  send = 'send',
  settings = 'settings',
  settings_off = 'settings_off',
  share = 'share',
  shield = 'shield',
  shield_off = 'shield_off',
  sidebar_left = 'sidebar_left',
  sidebar_right = 'sidebar_right',
  skull = 'skull',
  solution = 'solution',
  spinner = 'spinner',
  spy = 'spy',
  squares = 'squares',
  squares_rotated = 'squares_rotated',
  stack_large = 'stack_large',
  star = 'star',
  star_on = 'star_on',
  statistics = 'statistics',
  stop = 'stop',
  sub_scope = 'sub_scope',
  subscription = 'subscription',
  summary = 'summary',
  support = 'support',
  switch_off = 'switch_off',
  switch_on = 'switch_on',
  table = 'table',
  table_plus = 'table_plus',
  tag = 'tag',
  tags = 'tags',
  takedown = 'takedown',
  terminal = 'terminal',
  terms = 'terms',
  text = 'text',
  thumbs_down = 'thumbs_down',
  thumbs_up = 'thumbs_up',
  tie = 'tie',
  time = 'time',
  time_off = 'time_off',
  transfer = 'transfer',
  trend_down = 'trend_down',
  trend_up = 'trend_up',
  unlink = 'unlink',
  unwatch = 'unwatch',
  upload = 'upload',
  usage = 'usage',
  user = 'user',
  user_circle = 'user_circle',
  user_off = 'user_off',
  user_screen = 'user_screen',
  users = 'users',
  verification = 'verification',
  video = 'video',
  vulnerability = 'vulnerability',
  warning = 'warning',
  watch = 'watch',
  website = 'website',
  whats_new = 'whats_new',
  workflow = 'workflow',
  workspace = 'workspace',
  wrench = 'wrench',
  www = 'www',
}
